import { createFileRoute } from '@tanstack/react-router';

import { AdminEditUserModal } from '~/components/modals/user/AdminEditUserModal';
import { USER_ROLES } from '~/features/auth/roles';
import { useGoBack } from '~/hooks/useGoBack';
import { Route as CustomerAdminUsersRoute } from '~/routes/customer-administration/users';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'user-details';

export const Route = createFileRoute(
  '/customer-administration/users/profile/$userId',
)({
  component: EditUserRoute,
  params: {
    parse: (params) => ({ userId: params.userId }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AbbottUser, USER_ROLES.AdminAbbott],
    });
  },
});

function EditUserRoute() {
  const { userId } = Route.useParams();

  const goBack = useGoBack({ fallbackPath: CustomerAdminUsersRoute.fullPath });

  return (
    <AdminEditUserModal
      testID={TEST_ID}
      userId={userId}
      onCloseRedirectPath={CustomerAdminUsersRoute.fullPath}
      onActionComplete={goBack}
      disableActions
    />
  );
}
